export default function Phase1() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 1:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <span>The Best AI Filmmaking Tools</span>
          </h2>
          <p className="text-xl text-gray-700">
            <span>No expensive subscriptions required!</span>
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Hollywood VFX */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div 
              className="relative w-full mb-4 overflow-hidden rounded-lg" 
              style={{ 
                paddingBottom: '56.25%',
                touchAction: 'pan-y',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <iframe 
                src="https://player.mediadelivery.net/embed/555127/85186890-64bd-4bb3-87e7-3cd0b95d7745?autoplay=true&loop=true&muted=true&playsinline=true" 
                title="Fire hook final Video" 
                allow="autoplay; fullscreen" 
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ 
                  border: 'none',
                  pointerEvents: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
                loading="lazy"
              ></iframe>
            </div>
            <h5 className="text-xl font-bold text-gray-900 mb-3">Hollywood VFX</h5>
            <p className="text-base text-gray-700 leading-relaxed">
              In this course, you'll learn how to use powerful AI tools to create Hollywood-level visual effects without a big studio budget. From explosions and lighting effects to cinematic environments and motion graphics, you'll discover how to bring your videos to life with stunning visuals that look like they belong on the big screen.
            </p>
          </div>

          {/* Character Consistency */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div 
              className="relative w-full mb-4 overflow-hidden rounded-lg" 
              style={{ 
                paddingBottom: '56.25%',
                touchAction: 'pan-y',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <iframe 
                src="https://fast.wistia.net/embed/iframe/7q6weeo7v4?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
                title="Character Consistency Video" 
                allow="autoplay; fullscreen" 
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ 
                  border: 'none',
                  pointerEvents: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
                loading="lazy"
              ></iframe>
            </div>
            <h5 className="text-xl font-bold text-gray-900 mb-3">Character Consistency</h5>
            <p className="text-base text-gray-700 leading-relaxed">
              Consistency is key when building trust and recognition in your videos, and that includes your characters. In this course, you'll learn how to create and maintain AI-generated characters that look and act the same across every scene so your content feels polished, professional, and connected.
            </p>
          </div>

          {/* Clone Yourself */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div 
              className="relative w-full mb-4 overflow-hidden rounded-lg" 
              style={{ 
                paddingBottom: '56.25%',
                touchAction: 'pan-y',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <iframe 
                src="https://player.mediadelivery.net/embed/555127/ec503a55-13ab-4ed2-affc-620b1335b09a?autoplay=true&loop=true&muted=true&playsinline=true" 
                title="Clone Yourself Video" 
                allow="autoplay; fullscreen" 
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ 
                  border: 'none',
                  pointerEvents: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
                loading="lazy"
              ></iframe>
            </div>
            <h5 className="text-xl font-bold text-gray-900 mb-3">Clone Yourself</h5>
            <p className="text-base text-gray-700 leading-relaxed">
              You'll also learn how to create AI clones of yourself that can speak, move, and deliver content on your behalf. Whether you're making tutorials, promos, or social content, these realistic digital versions of you make it easy to scale your presence and stay on camera without always hitting record.
            </p>
          </div>

          {/* Cinematic Quality */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div 
              className="relative w-full mb-4 overflow-hidden rounded-lg" 
              style={{ 
                paddingBottom: '56.25%',
                touchAction: 'pan-y',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <iframe 
                src="https://player.mediadelivery.net/embed/555127/d1abdb86-32bc-4fc0-94aa-292798b69cda?autoplay=true&loop=true&muted=true&playsinline=true" 
                title="Cinematic Quality Video" 
                allow="autoplay; fullscreen" 
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ 
                  border: 'none',
                  pointerEvents: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
                loading="lazy"
              ></iframe>
            </div>
            <h5 className="text-xl font-bold text-gray-900 mb-3">Cinematic Quality</h5>
            <p className="text-base text-gray-700 leading-relaxed">
              To create incredible video content, you need AI tools that generate stunning, high-impact visuals. In this course, you'll discover the top video generators that produce results as good as, and often better than, real life. <strong>We also show how to access them WITHOUT needing an expensive subscription</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}